// Handles image loading errors globally across all pages by showing a placeholder image.
// Uses event delegation with capture phase since images may be dynamically loaded.
;(function () {
  const getPlaceholderUrl = () => {
    const meta = document.querySelector(
      "meta[property='failed-image-placeholder']",
    )
    return meta?.getAttribute("content")
  }

  const handleImageError = (event) => {
    const img = event.target
    if (img.tagName !== "IMG") return
    if (img.closest(".pswp")) return

    const placeholderUrl = getPlaceholderUrl()
    if (!placeholderUrl) return

    // Prevent infinite loop if placeholder itself fails
    if (img.src === placeholderUrl) return

    img.src = placeholderUrl
    img.srcset = ""
  }

  // Use capture phase since error events don't bubble
  document.addEventListener("error", handleImageError, true)
})()
